import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function ClientSlider() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  console.log(backendUrl);
  const { name } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${backendUrl}/cms/name/${name}`)
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching school data:", err);
        setLoading(false);
      });
  }, [backendUrl, name]);

  // Show loading state
  if (loading) {
    return (
      <LoadingContainer>
        <p>Loading carousel...</p>
      </LoadingContainer>
    );
  }

  // Check if data and carouselimg exist
  if (!data || !data.section2 || !data.section2.carouselimg || data.section2.carouselimg.length === 0) {
    return (
      <LoadingContainer>
        <p>No carousel images available</p>
      </LoadingContainer>
    );
  }

  const carouselImages = data.section2.carouselimg;
  
  // Create enough slides for smooth infinite scrolling
  const repeatedImages = [];
  const minSlides = Math.max(12, carouselImages.length * 3); // Ensure we have enough slides
  
  for (let i = 0; i < minSlides; i++) {
    repeatedImages.push(carouselImages[i % carouselImages.length]);
  }

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1, // Changed to 1 for smoother scrolling
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000, // Faster autoplay
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        {repeatedImages.map((imagePath, index) => (
          <LogoWrapper key={`slide-${index}`} className="flexCenter">
            <ImgStyle 
              src={`${backendUrl}${imagePath}`} 
              alt={`carousel image ${(index % carouselImages.length) + 1}`}
              onError={(e) => {
                console.error(`Failed to load image: ${backendUrl}${imagePath}`);
                e.target.style.display = 'none';
              }}
            />
          </LogoWrapper>
        ))}
      </Slider>
    </div>
  );
}

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  color: #666;
`;

const LogoWrapper = styled.div`
  width: 100%;
  height: 100px;
  cursor: pointer;
  :focus-visible {
    outline: none;
    border: 0px;
  }
`;

const ImgStyle = styled.img`
  width: 100%;
  height: 100%;
  padding: 10%;
  object-fit: contain;
`;